module.exports = __webpack_public_path__ + "static/media/Certificate-MC-2700-218x300.3067a002.jpg";